import { render } from "./index.vue?vue&type=template&id=098948a3&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=098948a3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-098948a3"

export default script